export const allOffers = [
  {
    id: 1,
    sats: [`4`],
    name: `Комплект "Ka.Heavy Ямал-601" для физ. лиц с антенной 0,75 м. (Акция!)`,
    saleOld: 0,
    saleNew: 12990,
    isRent: false,
    rent: 0,
    url: ``,
  },
  {
    id: 2,
    sats: [`4`],
    name: `Комплект "Ka.Heavy Ямал-601" для физ. лиц с антенной 0,75 м.`,
    saleOld: 0,
    saleNew: 29000,
    isRent: false,
    rent: 0,
    url: ``,
  },
  {
    id: 3,
    sats: [`1`],
    name: `Комплект "Ka.Heavy" для физ. лиц с антенной 0,74 м.`,
    saleOld: 0,
    saleNew: 35300,
    isRent: false,
    rent: 0,
    url: `https://da-tele.com/products/38124243`,
  },
  {
    id: 4,
    sats: [`1`],
    name: `Комплект "Ka.Heavy" для физ. лиц с антенной 0,98 м.`,
    saleOld: 0,
    saleNew: 54000,
    isRent: false,
    rent: 0,
    url: `https://da-tele.com/products/38124243`,
  },
  {
    id: 5,
    sats: [`4`],
    name: `"Ka.Heavy Бизнес Ямал-601" для юр. лиц с антенной 0,75 м.`,
    saleOld: 0,
    saleNew: 31200,
    isRent: false,
    rent: 0,
    url: ``,
  },
  {
    id: 6,
    sats: [`1`],
    name: `Комплект "Ka.Heavy Бизнес" для юр. лиц с антенной 0,74 м.`,
    saleOld: 0,
    saleNew: 45000,
    isRent: true,
    rent: 2650,
    url: `https://da-tele.com/products/26170680`,
  },
  {
    id: 7,
    sats: [`1`],
    name: `Комплект "Ka.Heavy Бизнес" для юр. лиц с антенной 0,98 м.`,
    saleOld: 0,
    saleNew: 60000,
    isRent: true,
    rent: 3530,
    url: `https://da-tele.com/products/26170680`,
  },
  {
    id: 8,
    sats: [`5`, `2`, `3`],
    name: `Комплект "Full" c антенной 1,2 м.`,
    saleOld: 0,
    saleNew: 72000,
    isRent: true,
    rent: 5200,
    url: `https://da-tele.com/products/26170719`,
  },
  {
    id: 9,
    sats: [`5`, `2`, `3`],
    name: `Комплект "Full" (Б/У) c антенной 1,2 м.`,
    saleOld: 0,
    saleNew: 33000,
    isRent: true,
    rent: 4200,
    url: `https://da-tele.com/products/26170719`,
  },
  {
    id: 10,
    sats: [`5`, `2`, `3`],
    name: `Комплект "Heavy" c антенной 1,2 м.`,
    saleOld: 0,
    saleNew: 155000,
    isRent: true,
    rent: 7150,
    url: `https://da-tele.com/products/26170690`,
  },

];
